module.exports = __webpack_public_path__ + "assets/img/89.f89a95d7.png";